<template>
  <div class="vue-login">
    <div class="background">
      <div class="footer-container">
        <div class="footer">
          <div class="row">
            <div class="col-lg-12">
              <div class="footer-content">
              <h3>Contact</h3>
              <p><strong>T</strong> &nbsp;&nbsp;{{ $root.companyPhone }}<br/>
              <strong>E</strong> &nbsp;&nbsp;<a :href="emailLink">{{ $root.companyEmail }}</a></p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-md-offset-9">
        <div class="logo pull-right">
          <img :src="logoUrl" :alt="$root.companyName" class="img-responsive login-logo">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="login-box">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VueLogin',
  computed: {
    logoUrl () {
      return 'https://techcar-dev.s3.amazonaws.com/' + this.$root.companyLogo
    },
    emailLink () {
      return 'mailto:' + this.$root.companyEmail
    }
  }
}
</script>



// WEBPACK FOOTER //
// VueLogin.vue?434db589